// Consolidated funds (fund groups) as delivered in globalConfigs.fund_groups
// by get_global_configs_v3. Deliberately a SEPARATE key from `funds`: groups
// are virtual umbrellas over member funds and must never appear in fund
// selectors (which are built from the `funds` list).
import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const FundGroupConfigModelSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    legal_name: z.string().nullish(),
    functional_currency_id: z.string().nullish(),
    primary_fund_id: z.string().nullish(),
    fund_ids: z.array(z.string())
  })
  .strict()

export const FundGroupConfigModelFields = makeFieldKeys(FundGroupConfigModelSchema)

export type FundGroupConfigModel = z.infer<typeof FundGroupConfigModelSchema>
